import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type {
  NotificationAttachmentKind,
  NotificationAudience,
  NotificationEvent,
} from "@/server-types";

export const EVENT_DISPLAY_NAME: Record<NotificationEvent, MessageDescriptor> =
  {
    appointmentReminder: msg`Opomnik termina`,
    appointmentFollowUp: msg`Sledenje po terminu`,
    newAppointment: msg`Nov termin`,
    rescheduled: msg`Prestavljen termin`,
    canceled: msg`Preklican termin`,
    noShow: msg`Ni se pojavil`,
    thankYouVisiting: msg`Hvala za obisk`,
    rebookReminder: msg`Opomnik za ponovno rezervacijo`,
    birthday: msg`Čestitke ob rojstnem dnevu`,
    winBack: msg`Privabi nazaj izgubljene stranke`,
    customerThreshold: msg`Mejnik stranke`,
    subscriptionPeriodThreshold: msg`Mejnik obdobja paketa`,
    subscriptionCreated: msg`Paket ustvarjen`,
    subscriptionPeriodEnding: msg`Obdobje paketa se izteka`,
    subscriptionEnded: msg`Paket končan`,
    subscriptionEndedFollowUp: msg`Paket končan — sledenje`,
    subscriptionLapsedFollowUp: msg`Paket potekel — sledenje`,
    subscriptionFreeze: msg`Paket zamrznjen`,
    subscriptionUnfreeze: msg`Paket odmrznjen`,
    subscriptionCanceled: msg`Paket preklican`,
    subscriptionPaymentRequest: msg`Poziv k plačilu`,
    subscriptionPaymentReminder: msg`Opomnik za plačilo`,
    subscriptionAutoCancelWarning: msg`Opozorilo pred samodejnim preklicem`,
    subscriptionAutoCanceled: msg`Preklic zaradi neplačila`,
    subscriptionRenewed: msg`Obnovitev paketa`,
    subscriptionBillingDocument: msg`Dokument obdobja`,
  };

export const AUDIENCE_LABEL: Record<NotificationAudience, MessageDescriptor> = {
  all: msg`Vse stranke`,
  newCustomer: msg`Nove stranke`,
  regularCustomer: msg`Redne stranke`,
};

export const ATTACHMENT_LABEL: Record<
  NotificationAttachmentKind,
  MessageDescriptor
> = {
  customerSubscriptionPeriodShareDocument: msg`dokument obdobja obvestila`,
  customerSubscriptionPreviousPeriodShareDocument: msg`dokument prejšnjega obdobja`,
  customerSubscriptionCurrentPeriodShareDocument: msg`dokument trenutnega obdobja`,
  customerSubscriptionNextPeriodShareDocument: msg`dokument naslednjega obdobja`,
};

export const ATTACHMENT_OPTION_LABEL: Record<
  NotificationAttachmentKind,
  MessageDescriptor
> = {
  customerSubscriptionPeriodShareDocument: msg`Dokument obdobja, o katerem je obvestilo`,
  customerSubscriptionPreviousPeriodShareDocument: msg`Dokument prejšnjega obdobja`,
  customerSubscriptionCurrentPeriodShareDocument: msg`Dokument trenutnega obdobja`,
  customerSubscriptionNextPeriodShareDocument: msg`Dokument naslednjega obdobja`,
};

export const DIRECTION_ANCHOR_LABEL: Partial<
  Record<NotificationEvent, MessageDescriptor>
> = {
  appointmentReminder: msg`začetkom termina`,
  appointmentFollowUp: msg`koncem termina`,
  thankYouVisiting: msg`koncem termina`,
  rebookReminder: msg`zadnjim opravljenim terminom`,
  subscriptionPeriodEnding: msg`koncem trenutnega obdobja`,
  subscriptionEndedFollowUp: msg`koncem paketa`,
  subscriptionLapsedFollowUp: msg`koncem zadnjega plačanega obdobja`,
  subscriptionPaymentRequest: msg`začetkom neplačanega obdobja`,
  subscriptionPaymentReminder: msg`začetkom neplačanega obdobja`,
  subscriptionAutoCancelWarning: msg`samodejnim preklicem zaradi neplačila`,
};
